NtechApp.Router = function() {
    var me = this;

    me._pageLoader = null;
    me._routePrefix = null;
    me._currentPageController = null;

    this._css = {
        ids: {
        },

        classes: {
        },

        data: {
        }
    }

    this._construct = function () {
        //me._pageLoader = new NtechApp.PageLoader();
        //me._routePrefix = NtechApp.config.baseUrl;
        //
        //me._bindRoutes();
        //me._bindEvents();
    }

    this._bindEvents = function () {
    }

    this._unbindEvents = function () {
        ;
    }

    this.destruct = function () {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.Router.ROUTE_CHANGE_EVENT = "routeChange.NtechApp.Router";
NtechApp.Router.ROUTES = {
    HOME: 0, ABOUT_US: 1, COLLECTIONS: 2, CONTACT_US: 3, CLIENTS: 4, ACCOUNT: 5
};

NtechApp.Router.prototype._getRoutePath = function(routePath) {
    return this._routePrefix + routePath;
};

NtechApp.Router.prototype._destroyCurrentPageController = function() {
    if(this._currentPageController == null)
        return;

    this._currentPageController.destruct();
};

NtechApp.Router.prototype._triggerRouteChangeEvent = function(routeName) {
    $(window).trigger(NtechApp.Router.ROUTE_CHANGE_EVENT, routeName);
};

NtechApp.Router.prototype._bindRoutes = function() {
    var me = this;
    var routes = NtechApp.Router.ROUTES;

    path(this._getRoutePath("/"), function() {
        me._destroyCurrentPageController();
        me._pageLoader.loadPage("landing_assets", "landing_html", function() {
            me._triggerRouteChangeEvent(routes.HOME);
            me._currentPageController = new NtechApp.HomeController();
        });
    });

    path(this._getRoutePath("/about-us"), function() {
        me._destroyCurrentPageController();
        me._pageLoader.loadPage("aboutus_assets", "aboutus_html", function() {
            me._triggerRouteChangeEvent(routes.ABOUT_US);
            me._currentPageController = new NtechApp.AboutUsController();
        });
    });

    path(this._getRoutePath("/contact-us"), function() {
        me._destroyCurrentPageController();
        me._pageLoader.loadPage("contactus_assets", "contactus_html", function() {
            me._triggerRouteChangeEvent(routes.CONTACT_US);
            me._currentPageController = new NtechApp.ContactUsController();
        });
    });

    var processProductsRoute = function(collectionType) {
        if((collectionType != "hotel-collection" && collectionType != "home-collection"
            && collectionType != "") && (typeof collectionType != "undefined")) {
            alert("Error: wrong collection type!");
            return;
        }

        if(collectionType == "" || typeof collectionType == "undefined") {
            var loadHtmlRoute = "collections_intro_html";
            var templateType = NtechApp.CollectionsController.TEMPLATE_TYPES.INTRO;
        }
        else if(collectionType == "hotel-collection") {
            var loadHtmlRoute = "collections_html";
            var templateType = NtechApp.CollectionsController.TEMPLATE_TYPES.HOTEL_COLLECTION;
        }
        else if(collectionType == "home-collection") {
            var loadHtmlRoute = "collections_home_html";
            var templateType = NtechApp.CollectionsController.TEMPLATE_TYPES.HOME_COLLECTION;
        }

        me._destroyCurrentPageController();
        me._pageLoader.loadPage("collections_assets", loadHtmlRoute, function() {
            me._triggerRouteChangeEvent(routes.COLLECTIONS);
            me._currentPageController = new NtechApp.CollectionsController(templateType);
        });
    }

    path(this._getRoutePath("/products"), function(collectionType) {
        processProductsRoute(collectionType);
    });

    path(this._getRoutePath("/products") + "/:collectionType", function(collectionType) {
        processProductsRoute(collectionType);
    });

    //path(this._getRoutePath("/clients"), function() {
    //    me._destroyCurrentPageController();
    //    me._pageLoader.loadPage("clients_assets", "clients_html", function() {
    //        me._triggerRouteChangeEvent(routes.CLIENTS);
    //        me._currentPageController = new NtechApp.ClientsController();
    //    });
    //});

    path(this._getRoutePath("/account"), function() {
        me._destroyCurrentPageController();
        me._pageLoader.loadPage("account_assets", "account_html", function() {
            me._triggerRouteChangeEvent(routes.ACCOUNT);
            me._currentPageController = new NtechApp.AccountController();
        });
    });
};